import type { ParagraphBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import { TextBlockBase } from './TextBlockBase'
import type { BlockAction } from './BlockActionsMenu'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onTextChange: (id: string, text: string) => void
  onToggleSelect: (id: string) => void
}

export function ParagraphBlockView({
  block,
  selected,
  frozen,
  animate,
  actions,
  onTextChange,
  onToggleSelect,
}: Props) {
  return (
    <BlockShell
      blockId={block.id}
      slug={block.slug}
      selected={selected}
      frozen={frozen}
      animate={animate}
      actions={actions}
      onToggleSelect={onToggleSelect}
      editable
    >
      <TextBlockBase
        as="p"
        readOnly={frozen}
        value={block.text}
        onChange={(next) => onTextChange(block.id, next)}
        className="text-sm leading-relaxed"
      />
    </BlockShell>
  )
}
